var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-8 bg-white"},[_vm._t("default"),_c('div',{staticClass:"row mx-3"},[_c('HsaBankOnboardingFooter')],1)],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }